<section
  class="min-h-[80vh] w-full grid place-items-center px-6 py-12 "
>
  <div class="w-full max-w-xl text-center">
    <div
      class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 ring-1 ring-red-100 shadow-sm"
    >
      <!-- Lock icon (SVG) -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="h-8 w-8"
        aria-hidden="true"
        fill="currentColor"
      >
        <path
          class="text-dc-commerce-red"
          d="M12 1a5 5 0 00-5 5v3H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V6a5 5 0 00-5-5zm-3 8V6a3 3 0 116 0v3H9z"
        />
      </svg>
    </div>

    <h1
      class="text-3xl font-semibold tracking-tight text-dc-navy"
    >
       {{ "UNAUTHORIZED" | translate}}
    </h1>

    <p class="mt-3 text-base text-gray-600 dark:text-gray-300">      
      {{ "NO_PERMISSION" | translate}}
    </p>

    <!-- Optional message from guard/interceptor -->
     @if(message){
        <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
        {{ message }}
        </p>
    }

    <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
     
      <app-button
          [type]="'button'"
          [label]="'BUTTONS.SIGN_IN' | translate"
          classesName="btn-edge-cut  btn-width-auto"
          (onBtnClick)="goToLogin()"
        />

       <app-button
          [type]="'button'"
          [label]="'BUTTONS.BACK_HOME' | translate"
          classesName="btn-edge-cut card-edge-cut-white btn-width-auto"
          (onBtnClick)="goHome()"
        />
    </div>
  </div>
</section>
